var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenBigGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9179 5.83639C12.795 4.75921 11.9401 3.90432 10.8629 3.78138L9.85428 4.78998C10.7582 5.2106 11.4887 5.94112 11.9093 6.845L12.9179 5.83639ZM3.45783 11.1864L8.33935 6.30491C9.41654 6.42785 10.2714 7.28274 10.3944 8.35992L5.51284 13.2414C5.47797 13.2763 5.44185 13.3097 5.40458 13.3416C5.14366 13.5647 4.82615 13.7133 4.48568 13.77L2.61795 14.0813L2.92924 12.2136C2.99409 11.8245 3.17889 11.4654 3.45783 11.1864ZM9.74006 2.22759L7.21653 4.75112L2.11952 9.84813C1.56166 10.406 1.19204 11.1242 1.06234 11.9024L0.605849 14.6414C0.463517 15.4954 1.20389 16.2358 2.05788 16.0934L4.79683 15.6369C5.57504 15.5072 6.29327 15.1376 6.85114 14.5797L11.9481 9.48274L14.4717 6.95921C14.6984 6.73251 14.8257 6.42504 14.8257 6.10444C14.8257 3.76778 12.9315 1.87354 10.5948 1.87354C10.2742 1.87354 9.96676 2.00089 9.74006 2.22759ZM0.946324 17.6456C0.423683 17.6456 0 18.0693 0 18.5919C0 19.1146 0.423683 19.5382 0.946324 19.5382H14.1949C14.7175 19.5382 15.1412 19.1146 15.1412 18.5919C15.1412 18.0693 14.7175 17.6456 14.1949 17.6456H0.946324Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenBigGray);
export default __webpack_public_path__ + "static/media/penBigGray.ffb612eb19e665456313acf2806dec4b.svg";
export { ForwardRef as ReactComponent };